import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { baseurl } from "../config";
import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import slides from "../data/Carousel.json";
import TypingText from "./framer/TypingText";
interface Slide {
  imageUrl: string;
  content: string;
  banner: string;
}
interface CustomCarouselProps {}

// const slides: Slide[] = carouselData;

const CustomCarousel = ({}: CustomCarouselProps) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery("(max-width:570px)");
  const isTab = useMediaQuery("(max-width:700px)");
  return (
    <Carousel
      interval={5000}
      autoPlay
      infiniteLoop
      showArrows={true}
      showThumbs={false}
    >
      {slides?.map((value: Slide, index: number) => (
        <Stack
          key={value.imageUrl}
          flexDirection={index % 2 === 0 ? "row" : "row-reverse"}
          sx={{
            position: "relative",
            backgroundColor: "black",
            width: isSmallScreen ? "fit-content" : "100%",
            height: isSmallScreen ? "fit-content" : "100%",
          }}
        >
          {isSmallScreen ? (
            <img
              width="100%"
              height="100%"
              src={`${baseurl}${value?.imageUrl}`}
              alt={`Image ${index}`}
            />
          ) : (
            <img src={`${baseurl}${value?.imageUrl}`} alt={`Image ${index}`} />
          )}

          {index % 2 === 0 ? (
            <Stack
              flexDirection={"column"}
              alignItems={"flex-end"}
              justifyContent={"center"}
              sx={{
                color: "white",
                position: "absolute",
                top: isSmallScreen ? "75%" : "65%",
                right: isSmallScreen ? "40%" : isTab ? "20%" : "10%",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: "white",
                  fontSize: isTab ? "1.5rem" : "2rem",
                  textAlign: "center",
                }}
              >
                {value?.banner}
              </Typography>
              <Typography
                variant="h1"
                sx={{
                  color: "customColors.clr1",
                  fontSize: isSmallScreen ? "1.5rem" : isTab ? "2rem" : "3rem",
                  fontFamily: "'Times New Roman', serif",
                  width: "100%",
                }}
              >
                <TypingText
                  baseText={value?.content}
                  duration={5}
                  delay={0}
                  repeat={Infinity}
                  backgroundColor="white"
                  height={isSmallScreen ? "1.5rem" : isTab ? "2rem" : "3rem"}
                  isCursorBlinker={true}
                />
              </Typography>
            </Stack>
          ) : (
            <Stack
              flexDirection={"column"}
              alignItems={"flex-start"}
              justifyContent={"center"}
              sx={{
                color: "white",
                position: "absolute",
                top: isSmallScreen ? "75%" : "65%",
                left: isSmallScreen ? "20%" : isTab ? "20%" : "10%",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: "white",
                  fontSize: isTab ? "1.5rem" : "2rem",
                  textAlign: "center",
                }}
              >
                {value?.banner}
              </Typography>
              <Typography
                variant="h1"
                sx={{
                  color: "customColors.clr1",
                  fontSize: isSmallScreen ? "1.5rem" : isTab ? "2rem" : "3rem",
                  fontFamily: "'Times New Roman', serif",
                  width: "100%",
                }}
              >
                <TypingText
                  baseText={value?.content}
                  duration={5}
                  delay={0}
                  repeat={Infinity}
                  backgroundColor="white"
                  height={isSmallScreen ? "1.5rem" : isTab ? "2rem" : "3rem"}
                  isCursorBlinker={true}
                />
              </Typography>
            </Stack>
          )}
        </Stack>
      ))}
    </Carousel>
  );
};

export default CustomCarousel;

// {index % 2 === 0 ? (

// ) : (
//   <Typography
//     variant="h4"
//     sx={{
//       position: "absolute",
//       top: isSmallScreen ? "70%" : "65%",
//       left: isSmallScreen ? "45%" : isTab ? "30%" : "20%",
//       transform: "translate(-50%, 50%)",
//       color: "white",
//       fontSize: isTab ? "1.5rem" : "2rem",
//       width: "50rem",
//       textAlign: "center",
//     }}
//   >
//     {value?.banner}
//   </Typography>
// )}

// {index % 2 === 0 ? (

// ) : (
//   <Typography
//     variant="h1"
//     sx={{
//       position: "absolute",
//       top: isSmallScreen ? "80%" : "75%",
//       left: isSmallScreen ? "40%" : isTab ? "40%" : "35%",
//       transform: "translate(-50%, 50%)",
//       color: "customColors.clr1",
//       fontSize: isSmallScreen ? "1.5rem" : isTab ? "2rem" : "3rem",
//       fontFamily: "'Times New Roman', serif",
//       width: "100%",
//     }}
//   >
//     <TypingText
//       baseText={value?.content}
//       duration={5}
//       delay={0}
//       repeat={Infinity}
//       backgroundColor="white"
//       height={isSmallScreen ? "1.5rem" : isTab ? "2rem" : "3rem"}
//       isCursorBlinker={true}
//     />
//   </Typography>
// )}
